import React, { useEffect, useState } from "react";
import {
  InputFieldText,
  InputFieldSelect,
  FieldGroup,
  Field,
  SubmitButton,
  ButtonContainer,
  FieldContainer,
  FormCard,
  SubmitButtonMail,
} from "../../reusable";

import { FormPartInterface, SaveValueInterface } from "../../../interfaces";
import { Checkbox } from "../../reusable/checkbox";
import { sectionValidation } from "../../../helpers";

export const ContactDetails = (props: FormPartInterface) => {
  const { saveValueFunct, isActive, assignGroup, validateSection } = props;
  const [currentStep, setCurrentStep] = useState(0);
  const [postCurrentStep, setPostCurrentStep] = useState(0);
  const [stepData, setStepData] = useState<any>({});
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [showErrorsTel, setShowErrorsTel] = useState(false);
  const [showErrorsEmail, setShowErrorsEmail] = useState(false);

  // No automatic validation – handled per-step on continue

  const validateField = (
    name: string,
    value: string
  ): { success: boolean; error: string } => {
    if (!value || value.trim() === "") {
      return { success: false, error: "This field is required" };
    }

    // Email validation
    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        return { success: false, error: "Please enter a valid email address" };
      }
    }
    // Phone validation - very permissive to allow international formats
    else if (name === "telephone") {
      const phoneRegex = /^[0-9\s\+\-\(\)\.]{6,20}$/;
      if (!phoneRegex.test(value)) {
        return { success: false, error: "Please enter a valid phone number" };
      }
    }

    return { success: true, error: "" };
  };

  const preSaveValueFunct = (dataToSave: SaveValueInterface) => {
    const saved = saveValueFunct(dataToSave);

    setStepData((prevData: any) => ({
      ...prevData,
      [dataToSave.field]: dataToSave.value,
    }));

    const validationResult = validateField(dataToSave.field, dataToSave.value);

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (!validationResult.success) {
        newErrors[dataToSave.field] = validationResult.error;
      } else {
        delete newErrors[dataToSave.field];
      }
      return newErrors;
    });

    return validationResult;
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep((s) => s - 1);
    } else {
      assignGroup("person");
    }
  };

  const handleContinue = () => {
    if (currentStep === 0) {
      setShowErrorsTel(true);
      const result = validateField("telephone", stepData.telephone || "");
      setErrors((prev) => ({
        ...prev,
        telephone: result.success ? "" : result.error,
      }));
      if (!result.success) return;
      setShowErrorsEmail(false);
      setCurrentStep(1);
      return;
    }

    setShowErrorsEmail(true);
    const result = validateField("email", stepData.email || "");
    setErrors((prev) => ({
      ...prev,
      email: result.success ? "" : result.error,
    }));
    if (!result.success) return;

    setTimeout(() => {
      assignGroup("medication");
    }, 400);
  };

  const getCurrentStep = () => {
    return isActive == "contact" ? (
      <FieldGroup title="Contact Information">
        <FormCard
          assignPostStep={setPostCurrentStep}
          step={currentStep}
          onBack={handleBack}
          isFirstStep={false}
        >
          <h3>Contact Details</h3>
          {currentStep === 0 && (
            <Field
              extraStyle={{ padding: "0" }}
              fieldLabel="Mobile number"
              labelPosition="left"
            >
              <InputFieldText
                fieldName="telephone"
                saveValue={preSaveValueFunct}
                populateValue={stepData.telephone || ""}
                fieldType={"tel"}
                required={true}
                showErrors={showErrorsTel}
                enhanced={true}
              />
            </Field>
          )}

          {currentStep === 1 && (
            <Field
              extraStyle={{ padding: "0" }}
              fieldLabel="Email"
              labelPosition="left"
            >
              <InputFieldText
                fieldName="email"
                saveValue={preSaveValueFunct}
                populateValue={stepData.email || ""}
                fieldType={"email"}
                required={true}
                showErrors={showErrorsEmail}
                enhanced={true}
              />
            </Field>
          )}

          <p style={{ color: "black", fontSize: "12px" }}>
            By clicking submit, you confirm you give your permission for
            Sentinel Legal Ltd to contact you by telephone, e-mail or post
            regarding your claim.
          </p>
          <div
            className="button-container"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <SubmitButtonMail
              text="Continue"
              btnType="primary"
              onClick={handleContinue}
              disabled={
                !(currentStep === 0
                  ? stepData.telephone &&
                    stepData.telephone.trim() !== "" &&
                    !errors.telephone
                  : stepData.email &&
                    stepData.email.trim() !== "" &&
                    !errors.email)
              }
            />
          </div>
        </FormCard>
      </FieldGroup>
    ) : (
      <></>
    );
  };

  return getCurrentStep();
};
